exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  padding: 24px;\n  background-color: white; }\n  .container__form {\n    display: grid; }\n    .container__form__button {\n      border: 0;\n      border-radius: 0.25rem;\n      background: var(--accent-color);\n      color: white;\n      font-family: system-ui, sans-serif;\n      font-size: 1rem;\n      line-height: 1.2;\n      white-space: nowrap;\n      text-decoration: none;\n      padding: 0.25rem 0.5rem;\n      margin: 0.25rem;\n      cursor: pointer; }\n", ""]);

// exports
